import { useRef, useState, useCallback } from "react";

const useSubmitLock = (cooldownMs = 1000) => {
    const lockRef = useRef(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const withLock = useCallback(async (fn) => {
        if (lockRef.current) return;

        lockRef.current = true;
        setIsSubmitting(true);

        try {
            await fn();
        } finally {
            setTimeout(() => {
                lockRef.current = false;
                setIsSubmitting(false);
            }, cooldownMs);
        }
    }, [cooldownMs]);

    const wrapSubmit = useCallback((fn) => {
        return async (e) => {
            if (e && e.preventDefault) e.preventDefault();
            await withLock(() => fn(e));
        };
    }, [withLock]);

    return { withLock, isSubmitting, wrapSubmit };
};

export default useSubmitLock;
